import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=146709d8&scoped=true"
import script from "./Location.vue?vue&type=script&setup=true&lang=js"
export * from "./Location.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Location.vue?vue&type=style&index=0&id=146709d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146709d8",
  null
  
)

export default component.exports